import * as type from '../ActionTypes';

const initialState = {
  educationLoading: false,
  educationStatus: false,
  educationError: null,
  educationData: {},
  degreeLoading: false,
  degreeStatus: false,
  degreeError: null,
  degreeData: [],
  degreeMsg: null,
  getDegreeData: [],
  degreeDeleteStatus: false,
  certificateLoading: false,
  certificateStatus: false,
  certificateError: null,
  certificateData: [],
  getCertificateData: [],
  certificateMsg: null,
  certificateDeleteStatus: false
};

export default function educationForm(state = initialState, action: any) {
  switch (action.type) {
    // for education
    case type.SAVE_EDUCATION_QUALIFICATION:
      return {
        ...state,
        educationLoading: true,
        educationError: null
      };
    case type.SAVE_EDUCATION_QUALIFICATION_SUCCESS:
      return {
        ...state,
        educationLoading: false,
        educationError: null,
        educationData: action?.data,
        educationStatus: true
      };
    case type.SAVE_EDUCATION_QUALIFICATION_FAILURE:
      return {
        ...state,
        educationLoading: false,
        educationError: action?.error,
        educationStatus: false
      };
    case type.UPDATE_EDUCATION_QUALIFICATION:
      return {
        ...state,
        educationLoading: true,
        educationError: null,
        educationStatus: false
      };
    // for degree
    case type.SAVE_DEGREE:
      return {
        ...state,
        degreeLoading: true,
        degreeStatus: false,
        degreeError: null,
        degreeMsg: null
      };
    case type.SAVE_DEGREE_SUCCESS:
      return {
        ...state,
        degreeLoading: false,
        degreeError: null,
        degreeData: action?.data,
        degreeStatus: true
      };
    case type.SAVE_DEGREE_FAILURE:
      return {
        ...state,
        degreeLoading: false,
        degreeError: action?.error,
        degreeStatus: false,
        degreeMsg: null,
        degreeDeleteStatus: false
      };
    case type.GET_DEGREE:
      return {
        ...state,
        degreeError: null,
        degreeMsg: null
      };
    case type.GET_DEGREE_SUCCESS:
      return {
        ...state,
        degreeError: null,
        getDegreeData: action?.data
      };
    case type.GET_DEGREE_FAILURE:
      return {
        ...state,
        degreeError: action?.error
      };
    case type.UPDATE_DEGREE:
      return {
        ...state,
        degreeLoading: true,
        educationError: null,
        degreeMsg: null,
        degreeStatus: false
      };
    case type.DELETE_DEGREE:
      return {
        ...state,
        educationError: null,
        degreeDeleteStatus: false,
        degreeMsg: null
      };
    case type.DELETE_DEGREE_SUCCESS:
      return {
        ...state,
        educationError: null,
        degreeMsg: action?.message,
        degreeDeleteStatus: true
      };
    // for certificate
    case type.SAVE_CERTIFICATE:
      return {
        ...state,
        certificateLoading: true,
        certificateError: null,
        certificateStatus: false,
        certificateMsg: null
      };
    case type.SAVE_CERTIFICATE_SUCCESS:
      return {
        ...state,
        certificateLoading: false,
        certificateError: null,
        certificateData: action?.data,
        certificateStatus: true
      };
    case type.SAVE_CERTIFICATE_FAILURE:
      return {
        ...state,
        certificateLoading: false,
        certificateError: action?.error,
        certificateStatus: false,
        certificateMsg: null,
        certificateDeleteStatus: false
      };
    case type.GET_CERTIFICATE:
      return {
        ...state,
        certificateError: null,
        certificateMsg: null
      };
    case type.GET_CERTIFICATE_SUCCESS:
      return {
        ...state,
        getCertificateData: action?.data
      };
    case type.GET_CERTIFICATE_FAILURE:
      return {
        ...state,
        certificateLoading: false,
        certificateError: action?.error
      };
    case type.UPDATE_CERTIFICATE:
      return {
        ...state,
        certificateLoading: true,
        educationError: null,
        certificateMsg: null,
        certificateStatus: false
      };
    case type.DELETE_CERTIFICATE:
      return {
        ...state,
        educationError: null,
        certificateDeleteStatus: false,
        certificateMsg: null
      };
    case type.DELETE_CERTIFICATE_SUCCESS:
      return {
        ...state,
        educationError: null,
        certificateDeleteStatus: true,
        certificateMsg: action?.message
      };
    case type.RESET_EDUCATION_DEGREE_CERTIFICATE_STATUS:
      return {
        ...state,
        educationStatus: false,
        degreeStatus: false,
        certificateStatus: false
      };
    case type.RESET_DEGREE_DATA:
      return {
        ...state,
        degreeStatus: false,
        degreeData: []
      };
    case type.RESET_CERTIFICATE_DATA:
      return {
        ...state,
        certificateStatus: false,
        certificateData: []
      };
    case type.RESET_REGISTER_USER:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
